<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import wxjsdk from 'weixin-js-sdk'
import VConsole from 'vconsole'
if (localStorage.getItem('GUIDERUSER.accountId') === '537') {
//   // 吐槽一波：不支持 import 方式
  new VConsole()
} else if (window.location && window.location.hash.indexOf('debbugShenyu') !== -1) {
  new VConsole()
}
export default {
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
    this.$toast.setDefaultOptions({
      duration: 1500
    })
    // this.hideMenuItems()
    // if (typeof WeixinJSBridge === 'undefined') {
    //   if (document.addEventListener) {
    //     document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
    //   } else if (document.attachEvent) {
    //     document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
    //     document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
    //   }
    // } else {
    //   this.onBridgeReady()
    // }
    // this.getTempStr()
  },
  methods: {
    // onBridgeReady() {
    //   WeixinJSBridge.call('hideOptionMenu')
    // }
  }
}
</script>
<style lang="scss">
#app {
  min-height: 100vh;
  background: #f9f8f8;
  color:#171717;
}
.van-tabbar--fixed {
  z-index: 100 !important;
}
</style>
